import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import { DEFAULT_LOCALE, INTL_LOCALE, type AppLocale } from './locales'

export type MessageSchema = typeof en

export const i18n = createI18n<[MessageSchema], AppLocale, false>({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: { en } as Record<AppLocale, MessageSchema>,
  missingWarn: import.meta.env.DEV,
  fallbackWarn: false,
})

// English ships in the main bundle as the fallback; other locales are lazy-loaded.
const loaders: Record<AppLocale, () => Promise<{ default: MessageSchema }>> = {
  en: () => Promise.resolve({ default: en }),
  am: () => import('./locales/am.json'),
}

const loaded = new Set<AppLocale>(['en'])

export async function setI18nLocale(locale: AppLocale) {
  if (!loaded.has(locale)) {
    const messages = await loaders[locale]()
    i18n.global.setLocaleMessage(locale, messages.default)
    loaded.add(locale)
  }
  i18n.global.locale.value = locale
  document.documentElement.lang = locale
}

export function intlLocale(locale: AppLocale = i18n.global.locale.value): string {
  return INTL_LOCALE[locale]
}
